import URL from "./apiURL";
import api from "../../utils/axiosInstance";
/**
 * Function to call ask Chat Bot API
 * @body
 * @returns
 */
export async function incidentReport(payload) {
  try {
    const res = await api.post(URL.incidentReportApi, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Error executing incident report:", error);
    throw error;
  }
}
